import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ScrollReveal from "./ScrollReveal";

const servicesData = [
  {
    title: "Security Consultation",
    description:
      "Expert-led security consultation to assess risk, define strategy, and guide organisations toward stronger, more resilient security decisions.",
    bgImage:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto:good,w_1200/v1768132524/Consultation_jmazis.png",
    link: "services/security-consulting-advisory",
  },
  {
    title: "Design And Deploy",
    description:
      "We design and deploy secure architectures, controls, and platforms tailored to your business, ensuring security is built correctly from day one.",
    bgImage:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto:good,w_1200/v1768132525/Design_and_Deploy_hneg77.png",
    link: "/services/design-and-deploy",
  },

  {
    title: "Managed Security Services",
    description:
      "24/7 cyber security capabilities delivered by our team of experienced analysts.",
    bgImage:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto:good,w_1200/v1768497161/Managed_security_services_b0hpjs.png",
    link: "/services/managed-security-services",
  },

  {
    title: "Managed Detection And Response",
    description:
      "Continuous threat detection and rapid response powered by expert analysts to stop attacks before they impact your business.",

    bgImage:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto:good,w_1200/v1773480312/Managed_detection_and_response_ngutfc.png",
    link: "/services/detection-and-response",
  },
  {
    title: "Incident Response",
    description:
      "Swift, expert-led incident containment and recovery to minimize damage, restore operations, and strengthen your security posture.",
    bgImage:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto:good,w_1200/v1769784255/Incident_Response_jaay1d.png",
    link: "services/incident-response",
  },
];

const ServiceSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <ScrollReveal>
      <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-[#032d28] py-16 lg:py-24">
        {" "}
        {/* Constant Background Image */}
        {/* <div
        className="absolute inset-0 z-0 opacity-40 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://res.cloudinary.com/dpn3bkjba/image/upload/v1759564406/Gemini_Generated_Image_jurgc1jurgc1jurg_zrr0ia.png')`,
        }}
      /> */}
        <div className="relative z-10 w-full max-w-[1500px]  px-4 md:px-10">
          <div className="mb-14 px-4 text-center md:text-left">
            <p className="text-[#00C08B] font-bold uppercase tracking-widest text-xl mb-3">
              Our Services
            </p>
            <h2 className="text-4xl  text-[#ffffff] md:text-5xl  font-bold tracking-tight mb-4">
              End-to-end Cyber Security Expertise
            </h2>
            <p className="text-lg text-emerald-100/70 max-w-5xl mx-auto leading-relaxed text-center md:translate-x-0">
              {" "}
              Consult, build, manage, and respond complete security services
              across your entire environment.
            </p>
          </div>

          {/* Removed gaps and rounded corners to ensure seamless card edges */}
          <div className="flex flex-col lg:flex-row w-full min-h-[600px] lg:h-[600px] gap-0 overflow-hidden rounded-3xl shadow-2xl border border-white/10">
            {servicesData.map((service, index) => {
              const isActive = activeIndex === index;

              return (
                <motion.div
                  key={index}
                  layout
                  onClick={() => setActiveIndex(index)} // Essential for mobile
                  onMouseEnter={() => setActiveIndex(index)}
                  className={`relative cursor-pointer transition-all duration-500 ease-in-out border-b lg:border-b-0 lg:border-r border-white/10 last:border-0
          ${
            isActive
              ? "h-[450px] lg:flex-[4] lg:h-full"
              : "h-[70px] lg:flex-[0.8] lg:h-full"
          }
        `}
                  style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.15), rgba(0,0,0,0.45)), url(${service.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="absolute inset-0 flex flex-col justify-end p-6">
                    <AnimatePresence mode="wait">
                      {isActive ? (
                        <motion.div
                          key="active"
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0 }}
                          className="w-full"
                        >
                          <h3 className="text-xl md:text-3xl font-bold text-white mb-2">
                            {service.title}
                          </h3>
                          <p className="text-gray-200 text-sm md:text-base mb-4 leading-snug">
                            {service.description}
                          </p>
                          <a
                            href={service.link}
                            className="inline-block text-emerald-400 font-bold text-xs uppercase tracking-widest"
                          >
                            Explore Service &rarr;
                          </a>
                        </motion.div>
                      ) : (
                        <motion.div
                          key="collapsed"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          className="absolute inset-0 flex items-center justify-start px-6"
                        >
                          <h3 className="text-sm font-bold text-white uppercase tracking-wider opacity-80">
                            {service.title}
                          </h3>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default ServiceSection;
